<style>
@import '../../assets/css/tool.css';
</style>

<template>
    <div class="main-panel" v-if="ajaxLoad === true">
        <div class="main-content">
            <div class="container-fluid">
                <b-card :header="$t($route.name)">
                    <b-button variant="primary" class="mb-3 float-right" @click="getAddPackage()" v-if="permissionList.includes(permission.add)"><font-awesome-icon icon="plus"/> {{$t('setting_package.table_add')}}</b-button>
                    <el-table class="custom-table" :data="ajaxTable" @expand-change="expandChange" @row-click="expandRow" ref="tableTest" border>
                        <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.prop" :min-width="title.width">
                            <template slot="header">
                                <p>{{title.label}}</p>
                                <b-form-input :placeholder="title.label" @keyup.enter="initialize()" v-model="ajaxSearch[title.prop]"></b-form-input>
                            </template>
                        </el-table-column>
                        <el-table-column type="expand">
                            <b-button variant="info" size="lg" @click="getEditPackage()" v-if="permissionList.includes(permission.edit)">{{$t('setting_package.table_edit')}}</b-button>
                            <b-button variant="primary" size="lg" class="ml-1" @click="getAttributePackage()">{{$t('setting_package.table_package_attribute')}}</b-button>
                            <b-button variant="danger" size="lg" class="ml-1" @click="deletePackage()" v-if="permissionList.includes(permission.delete)">{{$t('setting_package.table_delete')}}</b-button>
                        </el-table-column>
                    </el-table>
                    <div class="mt-3">
                        <span class="float-left">{{$t('admin.table_show_result',{result:ajaxTool.total_number})}}</span>
                        <el-pagination class="text-right" layout="sizes,prev, pager, next" @size-change="paginationSizeChange" @current-change="paginationCurrentChange" :current-page.sync="ajaxTool.current_pagination" :total="ajaxTool.total_number" :hide-on-single-page="1" :page-sizes="[10, 30, 50, 100]" :page-size="10" background></el-pagination>
                    </div>
                </b-card>
                
                <b-modal id="addPackage" :title="$t('setting_package.table_add')" @ok="addPackage" :cancelTitle="$t('button.close')" :okTitle="$t('button.submit')">
                    <form id="addPackageForm" @submit.prevent="addPackage">
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting_package.table_code')}}</template>
                            <b-form-input name="code" v-model="ajaxAdd.code"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting_package.table_sales_value')}}</template>
                            <b-form-input name="sales_value" v-model="ajaxAdd.sales_value"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting_package.table_bonus_value')}}</template>
                            <b-form-input name="bonus_value" v-model="ajaxAdd.bonus_value"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting_package.table_sort')}}</template>
                            <b-form-input name="sort" v-model="ajaxAdd.sort" ></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting_package.table_filter')}}</template>
                            <b-form-checkbox-group name="filter[]" v-model="ajaxAdd.filter">
                                <b-form-checkbox value="register" class="mt-2">{{$t('setting_package.table_register')}}</b-form-checkbox>
                                <b-form-checkbox value="upgrade" class="mt-2">{{$t('setting_package.table_upgrade')}}</b-form-checkbox>
                                <b-form-checkbox value="repurchase" class="mt-2">{{$t('setting_package.table_repurchase')}}</b-form-checkbox>
                                <b-form-checkbox value="maintain" class="mt-2">{{$t('setting_package.table_maintain')}}</b-form-checkbox>
                            </b-form-checkbox-group>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting_package.table_status')}}</template>
                            <b-form-checkbox name="status" v-model="ajaxAdd.status" size="lg" value="1" unchecked-value="0" switch></b-form-checkbox>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="12" >
                            <template slot="label">{{$t('setting_package.table_name_title')}}</template>
                            <b-tabs class="center_pane" justified fill>
                                <b-tab v-for="(lang,key) in ajaxAdd.languageList" :key="key" :title="lang.name">
                                    <b-form-group label-cols="12" label-cols-lg="4">
                                        <template slot="label">{{$t('setting_package.table_name')}}</template>
                                        <b-form-input :name="'name[' + lang.code + ']'" v-model="ajaxAdd.name[lang.code]"></b-form-input>
                                    </b-form-group>
                                </b-tab>
                            </b-tabs>
                        </b-form-group>
                    </form>
                </b-modal>
                <b-modal id="editPackage" :title="$t('setting_package.table_edit')" @ok="editPackage" :cancelTitle="$t('button.close')" :okTitle="$t('button.submit')">
                    <form id="editPackageForm" @submit.prevent="editPackage">
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting_package.table_code')}}</template>
                            <b-form-input name="code" v-model="ajaxEdit.code"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting_package.table_sales_value')}}</template>
                            <b-form-input name="sales_value" v-model="ajaxEdit.sales_value"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting_package.table_bonus_value')}}</template>
                            <b-form-input name="bonus_value" v-model="ajaxEdit.bonus_value"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting_package.table_sort')}}</template>
                            <b-form-input name="sort" v-model="ajaxEdit.sort" ></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting_package.table_filter')}}</template>
                            <b-form-checkbox-group name="filter[]" v-model="ajaxEdit.filter">
                                <b-form-checkbox value="register" class="mt-2">{{$t('setting_package.table_register')}}</b-form-checkbox>
                                <b-form-checkbox value="upgrade" class="mt-2">{{$t('setting_package.table_upgrade')}}</b-form-checkbox>
                                <b-form-checkbox value="repurchase" class="mt-2">{{$t('setting_package.table_repurchase')}}</b-form-checkbox>
                                <b-form-checkbox value="maintain" class="mt-2">{{$t('setting_package.table_maintain')}}</b-form-checkbox>
                            </b-form-checkbox-group>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting_package.table_status')}}</template>
                            <b-form-checkbox name="status" v-model="ajaxEdit.status" size="lg" value="1" unchecked-value="0" switch></b-form-checkbox>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="12" >
                            <template slot="label">{{$t('setting_package.table_name_title')}}</template>
                            <b-tabs class="center_pane" justified fill>
                                <b-tab v-for="(lang,key) in ajaxEdit.languageList" :key="key" :title="lang.name">
                                    <b-form-group label-cols="12" label-cols-lg="4">
                                        <template slot="label">{{$t('setting_package.table_name')}}</template>
                                        <b-form-input :name="'name[' + lang.code + ']'" v-model="ajaxEdit.name[lang.code]"></b-form-input>
                                    </b-form-group>
                                </b-tab>
                            </b-tabs>
                        </b-form-group>
                    </form>
                </b-modal>
                <b-modal id="getAttributePackage" :title="$t('setting_package.table_attribute_title',{attribute:ajaxAttributePackage})" size="lg " hide-footer>
                    <b-tabs class="center_pane" justified fill>
                        <b-tab :title="$t('setting_package.table_attribute')" active>
                            <el-table class="custom-table" :data="ajaxAttributeTable" @expand-change="expandChangeAttribute" @row-click="expandRowAttribute" ref="tableAttribute" border>
                                <el-table-column v-for="title in attributeTitles" :prop="title.prop" :label="title.label" :key="title.prop" :min-width="title.width"></el-table-column>
                                <el-table-column type="expand">
                                    <b-button variant="info" @click="getEditAttributePackage()" v-if="permissionList.includes(permission.attribute_edit)">{{$t('setting_package.table_edit_attribute')}}</b-button>
                                    <b-button variant="danger" class="ml-1" @click="deleteAttributePackage()" v-if="permissionList.includes(permission.attribute_delete)">{{$t('setting_package.table_delete_attribute')}}</b-button>
                                </el-table-column>
                            </el-table>
                            <div class="mt-3">
                                <span class="float-left">{{$t('admin.table_show_result',{result:ajaxAttributeTool.total_number})}}</span>
                                <el-pagination class="text-right" layout="sizes,prev, pager, next" @size-change="paginationAttributeSizeChange" @current-change="paginationAttributeCurrentChange" :current-page.sync="ajaxAttributeTool.current_pagination" :total="ajaxAttributeTool.total_number" :hide-on-single-page="1" :page-sizes="[10, 30, 50, 100]" :page-size="10" background></el-pagination>
                            </div>
                        </b-tab>
                        <b-tab :title="$t('setting_package.table_add_attribute')">
                            <form id="addAttributePackage" @submit.prevent="addAttributePackage">                            
                                <b-form-group label-cols="12" label-cols-lg="4">
                                    <template slot="label">{{$t('setting_package.table_attribute')}}</template>
                                    <b-form-select class="mb-3" name="attribute_id">
                                        <option v-for="(list,index) in ajaxAttributeList" :key="index" :value="list.id">[{{list.code}}] - {{list.name}}</option>
                                    </b-form-select>
                                </b-form-group>
                                <b-form-group label-cols="12" label-cols-lg="4">
                                    <template slot="label">{{$t('setting_package.table_attribute_value')}}</template>
                                    <b-form-input name="value"></b-form-input>
                                </b-form-group>
                                <b-form-group label-cols="12" label-cols-lg="4">
                                    <b-button variant="primary" @click="addAttributePackage()" v-if="permissionList.includes(permission.attribute_add)">{{$t('button.submit')}}</b-button>
                                </b-form-group>
                            </form>
                        </b-tab>
                    </b-tabs>
                </b-modal>
                <b-modal id="getEditAttributePackage" :title="$t('setting_package.table_edit_attribute')" @ok="editAttributePackage" hide-footer>
                    <form id="editAttributePackage" @submit.prevent="editAttributePackage">
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting_package.table_attribute_value_select')}}</template>
                            <p class="mt-2">{{ajaxAttributeEdit.code}}</p>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting_package.table_attribute_value')}}</template>
                            <b-form-input name="value" v-model="ajaxAttributeEdit.value"></b-form-input>
                        </b-form-group>
                        <b-button variant="primary" @click="editAttributePackage()">{{$t('button.submit')}}</b-button>
                    </form>
                </b-modal>
            </div>
        </div>
    </div>
</template>

<script>
import {languageList,setting_packageAjaxTable,setting_packageAdd,getSetting_PackageEdit,setting_packageEdit,setting_packageDelete,setting_packageAttributeAjaxTable,setting_packageAttributeAdd,getSetting_PackageAttributeEdit,setting_packageAttributeEdit,setting_packageAttributeDelete,setting_packageAttributeLimit,setting_packageAttributePagination} from '@/system/model/tools'
import {removeTokenByName} from '@/system/store/cookie';
import {getSessionStorage,setSessionStorage } from '@/system/store/sessionstorage';
import {setLocalStorage, getLocalStorage} from '@/system/store/localstorage';

export default {
    inject:['preloader'],
    data(){
        return{   
            ajaxLoad:false,
            validate:true,
            ajaxTable:[],
            ajaxTool:[],
            ajaxSearch:{limit:'',pagination:'',id:'',code:'',sales_value:'',bonus_value:'',filter:'',sort:10,status:1},
            ajaxAdd:{id:'',code:'',sales_value:'',bonus_value:'',filter:'',sort:10,status:1,name:{en:'',cn:''},languageList:[]},
            ajaxEdit:{languageList:[]},
            ajaxRow:'',
            ajaxAttributeTable:[],
            ajaxAttributePackage:[],
            ajaxAttributeTool:[],
            ajaxAttributeSearch:[],
            ajaxAttributeEdit:[],
            ajaxAttributeList:[],
            ajaxAttributeRow:'',
            csrfName:'',
            csrfValue:'',
            csrfNameKey:'',
            csrfValueKey:'',
            pageLimit:10,
            pageAttributeLimit:10,
            errors: [],
            permission:{
                add:'F09EA6',
                edit:'24CC26',
                delete:'537322',
                attribute_add:'60D808',
                attribute_edit:'86E201',
                attribute_delete:'F7CFDB'
            },
            permissionList:[],
            titles:[{
                prop: "id",
                label: this.$t('setting_package.table_id'),
                width: '190'
            },{
                prop: "code",
                label: this.$t('setting_package.table_code'),
                width: '190'
            },{
                prop: "sales_value",
                label: this.$t('setting_package.table_sales_value'),
                width: '190'
            },{
                prop: "bonus_value",
                label: this.$t('setting_package.table_bonus_value'),
                width: '190'
            },{
                prop: "filter",
                label: this.$t('setting_package.table_filter'),
                width: '380'
            },{
                prop: "sort",
                label: this.$t('setting_package.table_sort'),
                width: '190'
            },{
                prop: "status",
                label: this.$t('setting_package.table_status'),
                width: '190'
            }], 
            attributeTitles:[{
                prop: "id",
                label: this.$t('setting_package.table_id'),
                width: '83'
            },{
                prop: "attribute_id",
                label: this.$t('setting_package.table_attribute'),
                width: '250'
            },{
                prop: "value",
                label: this.$t('setting_package.table_attribute_value'),
                width: '250'
            }], 
        }
    },methods:{
        initialize(){
            var self = this;
            var result = setting_packageAjaxTable(this.ajaxSearch.limit,this.ajaxSearch.pagination,this.ajaxSearch.id,this.ajaxSearch.code,this.ajaxSearch.sales_value,this.ajaxSearch.bonus_value,this.ajaxSearch.filter,this.ajaxSearch.sort,this.ajaxSearch.status);
            this.preloader(true);
            result.then(function(value){
                self.preloader(false);
                if(value.valid){
                    self.ajaxLoad = true;
                    self.ajaxTable = value.data.datatable.data;
                    self.ajaxTool = value.data.datatable;
                    self.csrfName = value.data.csrf_list.csrf_name;
                    self.csrfValue = value.data.csrf_list.csrf_value;
                    self.csrfNameKey = value.data.csrf_list.csrf_name_key;
                    self.csrfValueKey = value.data.csrf_list.csrf_value_key;
                    self.permissionList = JSON.parse(getLocalStorage('permission_list'));
                }else{
                    self.$swal.fire({
                        type: 'error',
                        html: self.$t('login.error_relogin'),
                        onClose: () => {
                            removeTokenByName('auth_sign_token');
                            self.$router.push('/');
                        }
                    });		
                }
            });
        },getAddPackage(){
            if(this.permissionList.includes(this.permission.add)){
                var self = this;
                var result = languageList();
                this.preloader(true);
                result.then(function(value){
                    self.preloader(false);
                    if(value.valid){
                        self.ajaxAdd.languageList = value.data;
                        self.$bvModal.show('addPackage')
                    }
                });
            }
        },addPackage(){
            if(this.permissionList.includes(this.permission.add)){
                var self = this;
                this.preloader(true);
                this.errors = [];
                if(!this.ajaxAdd.code){
                    this.validate = false;
                    this.errors.push('setting_package.error_code_empty');
                }
                if(!this.ajaxAdd.sort){
                    this.validate = false;
                    this.errors.push('setting_package.error_sort_empty');
                }
                if(!this.ajaxAdd.name.cn){
                    this.validate = false;
                    this.errors.push('setting_package.error_name_empty');
                }
                if(!this.ajaxAdd.name.en){
                    this.validate = false;
                    this.errors.push('setting_package.error_name_empty');
                }
                if(this.validate){
                    var form = document.getElementById('addPackageForm');
                    var formData = new FormData(form);
                    formData.append(this.csrfNameKey, this.csrfName); 
                    formData.append(this.csrfValueKey, this.csrfValue); 
                    var result = setting_packageAdd(formData);
                    result.then(function(value){
                        self.preloader(false);
                        if(value.valid){
                            self.$swal.fire({
                                type: 'success',
                                text: self.$t(value.returnMsg),
                                onClose: () => {
                                    self.initialize();            
                                }
                            });
                        }else{
                            var text = "";
                            if(Array.isArray(value.returnMsg)){
                                value.returnMsg.forEach(function (value) {
                                    text += self.$t(value)+"<br />";
                                }); 
                            }else{
                                text = self.$t(value.returnMsg);
                            }

                            self.$swal.fire({
                                type: 'error',
                                html: text,
                                onClose: () => {
                                    self.initialize();            
                                }
                            });
                        }
                    });    
                }else{
                    this.validate = true;
                    this.preloader(false);
                    var text = "";
                    this.errors.forEach(function (value) {
                        text += self.$t(value)+"<br />";
                    }); 
                    
                    this.$swal.fire({
                        type: 'error',
                        html: text,
                    });
                }  
            }       
        },getEditPackage(){
            if(this.permissionList.includes(this.permission.edit)){
                var self = this;
                var result = getSetting_PackageEdit(this.ajaxRow);
                this.preloader(true);
                result.then(function(value){
                    self.preloader(false);
                    if(value.valid){
                        self.$bvModal.show('editPackage');
                        self.ajaxEdit = value.data;
                        self.ajaxEdit.languageList = value.language;
                    }else{
                        var text = "";
                        this.errors.forEach(function (value) {
                            text += self.$t(value)+"<br />";
                        }); 
                        
                        this.$swal.fire({
                            type: 'error',
                            html: text,
                        });
                    }
                })
            }
        },editPackage(){
            if(this.permissionList.includes(this.permission.edit)){
                var self = this;
                this.preloader(true);
                this.errors = [];
                if(!this.ajaxEdit.code){
                    this.validate = false;
                    this.errors.push('setting_package.error_code_empty');
                }
                if(!this.ajaxEdit.sort){
                    this.validate = false;
                    this.errors.push('setting_package.error_sort_empty');
                }
                if(!this.ajaxEdit.name.cn){
                    this.validate = false;
                    this.errors.push('setting_package.error_name_empty');
                }
                if(!this.ajaxEdit.name.en){
                    this.validate = false;
                    this.errors.push('setting_package.error_name_empty');
                }
                if(this.validate){
                    var form = document.getElementById('editPackageForm');
                    var formData = new FormData(form);
                    formData.append(this.csrfNameKey, this.csrfName); 
                    formData.append(this.csrfValueKey, this.csrfValue); 
                    formData.append('id', this.ajaxEdit.id); 
                    var result = setting_packageEdit(formData);
                    result.then(function(value){
                        self.preloader(false);
                        if(value.valid){
                            self.$swal.fire({
                                type: 'success',
                                text: self.$t(value.returnMsg),
                                onClose: () => {
                                    self.initialize();            
                                }
                            });
                        }else{
                            var text = "";
                            if(Array.isArray(value.returnMsg)){
                                value.returnMsg.forEach(function (value) {
                                    text += self.$t(value)+"<br />";
                                }); 
                            }else{
                                text = self.$t(value.returnMsg);
                            }

                            self.$swal.fire({
                                type: 'error',
                                html: text,
                                onClose: () => {
                                    self.initialize();            
                                }
                            });
                        }
                    })
                }else{
                    this.validate = true;
                    this.preloader(false);
                    var text = "";
                    this.errors.forEach(function (value) {
                        text += self.$t(value)+"<br />";
                    }); 
                
                    this.$swal.fire({
                        type: 'error',
                        html: text,
                    });
                } 
            }
        },deletePackage(){
            if(this.permissionList.includes(this.permission.delete)){
                this.$swal.fire({
                    text: this.$t('msg.confirm_delete'),
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonText: this.$t('button.confirm'),
                    cancelButtonText: this.$t('button.cancel'),
                }).then((result)=>{
                    if(result.value){
                        var self = this;
                        self.preloader(true);
                        var formData = new FormData();
                        formData.append(this.csrfNameKey, this.csrfName); 
                        formData.append(this.csrfValueKey, this.csrfValue); 
                        formData.append('id', this.ajaxRow); 
                        var result = setting_packageDelete(formData);		
                        result.then(function(value){
                            self.preloader(false);
                            if(value.valid){
                                self.$swal.fire({
                                    type: 'success',
                                    text: self.$t(value.returnMsg),
                                    onClose: () => {
                                        self.initialize();            
                                    }
                                });
                            }else{
                                self.preloader(false);
                                var text = "";
                                if(Array.isArray(value.returnMsg)){
                                    value.returnMsg.forEach(function (value) {
                                        text += self.$t(value)+"<br />";
                                    }); 
                                }else{
                                    text = self.$t(value.returnMsg);
                                }

                                self.$swal.fire({
                                    type: 'error',
                                    html: text,
                                    onClose: () => {
                                        self.initialize();            
                                    }
                                });
                            }
                        });
                    }
                });
            }
        },expandRow(row){
            this.$refs.tableTest.toggleRowExpansion(row);
            this.ajaxRow = row.id
        },expandChange(row,expandedRows){
            if(expandedRows.length>1){
                expandedRows.shift()
            }
        },paginationSizeChange(limit){
            this.ajaxSearch.limit = limit;
            this.initialize();
        },paginationCurrentChange(pagination){
            this.ajaxSearch.pagination = pagination;
            this.initialize();
        },getAttributePackage(){
            var self = this;
            var result = setting_packageAttributeAjaxTable(this.ajaxRow);
            this.preloader(true);
            result.then(function(value){
                self.preloader(false);
                self.$bvModal.show('getAttributePackage');
                self.ajaxAttributeTable = value.data.datatable.data;
                self.ajaxAttributeList = value.data.attribute_list;
                self.ajaxAttributePackage = value.data.package.code;
                self.ajaxAttributeTool = value.data.datatable;
                self.csrfName = value.data.csrf_list.csrf_name;
                self.csrfValue = value.data.csrf_list.csrf_value;
                self.csrfNameKey = value.data.csrf_list.csrf_name_key;
                self.csrfValueKey = value.data.csrf_list.csrf_value_key;
            });
        },addAttributePackage(){
            if(this.permissionList.includes(this.permission.attribute_add)){
                var self = this;
                var form = document.getElementById('addAttributePackage');
                var formData = new FormData(form);
                formData.append(this.csrfNameKey, this.csrfName); 
                formData.append(this.csrfValueKey, this.csrfValue); 
                formData.append('package_id', this.ajaxRow); 
                var result = setting_packageAttributeAdd(formData);
                self.preloader(true);
                result.then(function(value){
                    self.preloader(false);
                    if(value.valid){
                        self.$swal.fire({
                            type: 'success',
                            text: self.$t(value.returnMsg),
                            onClose: () => {                      
                                self.getAttributePackage();
                            }
                        });
                    }else{
                        self.preloader(false);
                        var text = "";
                        if(Array.isArray(value.returnMsg)){
                            value.returnMsg.forEach(function (value) {
                                text += self.$t(value)+"<br />";
                            }); 
                        }else{
                            text = self.$t(value.returnMsg);
                        }

                        self.$swal.fire({
                            type: 'error',
                            html: text,
                            onClose: () => {
                                self.getAttributePackage();
                            }
                        });
                    }
                });
            }
        },getEditAttributePackage(){
            if(this.permissionList.includes(this.permission.attribute_edit)){
                var self = this;
                var result = getSetting_PackageAttributeEdit(this.ajaxAttributeRow);
                this.preloader(true);
                result.then(function(value){
                    self.preloader(false);
                    self.$bvModal.show('getEditAttributePackage');
                    self.ajaxAttributeEdit = value.data;
                });
            }
        },editAttributePackage(){
            if(this.permissionList.includes(this.permission.attribute_edit)){
                var self = this;
                var form = document.getElementById('editAttributePackage');
                var formData = new FormData(form);
                formData.append(this.csrfNameKey, this.csrfName); 
                formData.append(this.csrfValueKey, this.csrfValue); 
                formData.append('id', this.ajaxAttributeEdit.id); 
                var result = setting_packageAttributeEdit(formData);
                self.preloader(true);
                result.then(function(value){
                    self.preloader(false);
                    if(value.valid){
                        self.$swal.fire({
                            type: 'success',
                            text: self.$t(value.returnMsg),
                            onClose: () => {
                                self.$bvModal.hide('getEditAttributePackage');                            
                                self.getAttributePackage();
                            }
                        });
                    }else{
                        self.preloader(false);
                        var text = "";
                        if(Array.isArray(value.returnMsg)){
                            value.returnMsg.forEach(function (value) {
                                text += self.$t(value)+"<br />";
                            }); 
                        }else{
                            text = self.$t(value.returnMsg);
                        }

                        self.$swal.fire({
                            type: 'error',
                            html: text,
                            onClose: () => {
                                self.$bvModal.hide('getEditAttributePackage');
                                self.getAttributePackage();
                            }
                        });
                    }
                });
            }
        },deleteAttributePackage(){
            if(this.permissionList.includes(this.permission.attribute_delete)){
                this.$swal.fire({
                    text: this.$t('msg.confirm_delete'),
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonText: this.$t('button.confirm'),
                    cancelButtonText: this.$t('button.cancel'),
                }).then((result)=>{
                    if(result.value){
                        var self = this;
                        self.preloader(true);
                        var formData = new FormData();
                        formData.append(this.csrfNameKey, this.csrfName); 
                        formData.append(this.csrfValueKey, this.csrfValue); 
                        formData.append('id', this.ajaxAttributeRow); 
                        var result = setting_packageAttributeDelete(formData);		
                        result.then(function(value){
                            self.preloader(false);
                            if(value.valid){
                                self.$swal.fire({
                                    type: 'success',
                                    text: self.$t(value.returnMsg),
                                    onClose: () => {
                                        self.getAttributePackage();
                                    }
                                });
                            }else{
                                self.preloader(false);
                                var text = "";
                                if(Array.isArray(value.returnMsg)){
                                    value.returnMsg.forEach(function (value) {
                                        text += self.$t(value)+"<br />";
                                    }); 
                                }else{
                                    text = self.$t(value.returnMsg);
                                }

                                self.$swal.fire({
                                    type: 'error',
                                    html: text,
                                    onClose: () => {
                                        self.getAttributePackage();
                                    }
                                });
                            }
                        });
                    }
                });
            }
        },paginationAttributeSizeChange(limit){
            var self = this;
            var result = setting_packageAttributeLimit(this.ajaxRow,limit);
            this.preloader(true);
            result.then(function(value){
                self.preloader(false);
                if(value.valid){
                    self.ajaxLoad = true;
                    self.pageAttributeLimit = limit;
                    self.ajaxAttributeTable = value.data.datatable.data;
                    self.ajaxAttributeList = value.data.attribute_list;
                    self.ajaxAttributePackage = value.data.package.code;
                    self.ajaxAttributeTool = value.data.datatable;
                    self.csrfName = value.data.csrf_list.csrf_name;
                    self.csrfValue = value.data.csrf_list.csrf_value;
                    self.csrfNameKey = value.data.csrf_list.csrf_name_key;
                    self.csrfValueKey = value.data.csrf_list.csrf_value_key;
                }
            });
        },paginationAttributeCurrentChange(current){
            var self = this;
            var result = setting_packageAttributePagination(this.ajaxRow,current,this.pageAttributeLimit);
            this.preloader(true);
            result.then(function(value){
                self.preloader(false);
                if(value.valid){
                    self.ajaxLoad = true;
                    self.ajaxAttributeTable = value.data.datatable.data;
                    self.ajaxAttributeList = value.data.attribute_list;
                    self.ajaxAttributePackage = value.data.package.code;
                    self.ajaxAttributeTool = value.data.datatable;
                    self.csrfName = value.data.csrf_list.csrf_name;
                    self.csrfValue = value.data.csrf_list.csrf_value;
                    self.csrfNameKey = value.data.csrf_list.csrf_name_key;
                    self.csrfValueKey = value.data.csrf_list.csrf_value_key;
                }
            });
        },expandRowAttribute(row){
            this.$refs.tableAttribute.toggleRowExpansion(row);
            this.ajaxAttributeRow = row.id
        },expandChangeAttribute(row,expandedRows){
            if(expandedRows.length>1){
                expandedRows.shift()
            }
        }
    },created(){
        this.preloader(false);
        this.initialize();
    }
}
</script>
